import React from "react";

import { useTheme } from "../../../../context/theme";
import { Box } from "../../../layout";
import { AvatarSize, avatarSizeToStylesMap } from "../consts";
import styles from "./LoadingPlaceholder.module.scss";

export default function LoadingPlaceholder({ size }: { size: AvatarSize }) {
  const { imageSize: placeholderSize } = avatarSizeToStylesMap[size];

  const theme = useTheme();

  return (
    <Box
      aria-label="Avatar loading"
      className={styles.loading}
      backgroundColor={theme["neutral-medium-surface"]}
      borderRadius="xxxlarge"
      width={placeholderSize}
      height={placeholderSize}
    />
  );
}
